<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Search-Customer",
  path: "customer",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
